import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { Reveal } from './Reveal';
import { PORTFOLIO } from '@/data';
import { INVESTOR } from '@/constants/testIds';

const monogram = (name) => {
  const words = name.replace(/[^\p{L}\s]/gu, '').split(/\s+/).filter(Boolean);
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
};

export const Portfolio = () => (
  <section
    id="portfolio"
    data-testid={INVESTOR.portfolio}
    className="mx-auto max-w-screen-2xl px-6 md:px-12 py-32 md:py-40"
  >
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-20">
      <Reveal>
        <span className="overline">03 — Portefeuille · Zukunft Real Estate GmbH</span>
        <h2 className="mt-6 font-display font-light tracking-tight text-5xl sm:text-6xl lg:text-7xl text-foreground">
          Les participations
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="max-w-xs font-body font-light leading-relaxed text-muted-foreground">
          Une sélection d'entreprises détenues et accompagnées par le family
          office, du premier chèque à la mise à l'échelle.
        </p>
      </Reveal>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
      {PORTFOLIO.map((p, i) => (
        <Reveal key={p.id} delay={(i % 3) * 0.08}>
          <motion.a
            href={p.url || '#'}
            target={p.url && p.url !== '#' ? '_blank' : undefined}
            rel="noopener noreferrer"
            data-testid={INVESTOR.portfolioItem(p.id)}
            whileHover="hover"
            initial="rest"
            animate="rest"
            className="group relative flex h-full min-h-[340px] flex-col justify-between border border-border bg-[#101216] p-8 transition-colors duration-500 hover:border-primary/50"
          >
            <div className="flex items-start justify-between">
              {/* Monogram lettermark */}
              <motion.div
                variants={{ rest: {}, hover: {} }}
                className="flex h-20 w-20 items-center justify-center border border-primary/40 bg-primary/[0.06] transition-colors duration-500 group-hover:bg-primary group-hover:border-primary"
              >
                <span className="font-display text-3xl leading-none tracking-tight text-primary transition-colors duration-500 group-hover:text-primary-foreground">
                  {monogram(p.name)}
                </span>
              </motion.div>
              <span className="font-mono text-[0.6rem] uppercase tracking-[0.2em] text-muted-foreground">
                {p.stage}
              </span>
            </div>

            <div>
              <div className="font-mono text-[0.6rem] uppercase tracking-[0.2em] text-primary mb-3">
                {p.sector}
              </div>
              <h3 className="font-display font-light text-4xl tracking-tight text-foreground mb-4">
                {p.name}
              </h3>
              <p className="font-body font-light text-sm leading-relaxed text-muted-foreground pr-4">
                {p.description}
              </p>

              <div className="mt-6 flex items-center gap-2 text-muted-foreground group-hover:text-primary transition-colors duration-500">
                <span className="font-mono text-[0.6rem] uppercase tracking-[0.22em]">
                  {p.url && p.url !== '#' ? 'Visiter' : 'Détails sur demande'}
                </span>
                <motion.span
                  variants={{ rest: { x: 0, y: 0, opacity: 0.5 }, hover: { x: 3, y: -3, opacity: 1 } }}
                  transition={{ duration: 0.4, ease: [0.19, 1, 0.22, 1] }}
                >
                  <ArrowUpRight size={15} strokeWidth={1.5} />
                </motion.span>
              </div>
            </div>
          </motion.a>
        </Reveal>
      ))}
    </div>
  </section>
);
